<!-- <app-property-header></app-property-header>
<app-property-search 
    [paginate]="true"
    [lazyLoad]="true"
    [showform]="false"
    [autoSearch]="true"
    [autosearchCriteriaPath]="'cfvars:PropertySearch:PropertySearchCriteria'"
  ></app-property-search> -->
  <!-- <app-connect-configuration></app-connect-configuration> -->
  <app-manage-bid-instruction></app-manage-bid-instruction>